import { useLocation, useNavigate } from 'react-router-dom';

import Button from '../../../Button';
import { IAuthAction, IAuthHeader } from './AuthHeader.types';
import PayfiPrimaryLogo from '../../../../assets/images/payfi-primary-logo.svg';

import AuthHeaderStyle from './AuthHeader.module.scss';

const authActions: Record<string, IAuthAction> = {
  '/login': {
    instruction: "Don't have an account?",
    buttonTitle: 'Sign Up',
    navigatePath: '/get-started'
  },
  '/get-started': {
    instruction: 'Already have an account?',
    buttonTitle: 'Login',
    navigatePath: '/'
  }
};

const AuthHeader = ({ className }: IAuthHeader) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const renderAuthActions = (path: string) => {
    const action = authActions[path];

    if (!action) {
      return null;
    }
    return (
      <>
        <p className={AuthHeaderStyle.authHeader__authInstruction}>{action.instruction}</p>
        <Button
          className={AuthHeaderStyle.authHeader__authInstructionBtn}
          title={action.buttonTitle}
          color="primary"
          type="button"
          onPress={() => navigate(action.navigatePath)}
        />
      </>
    );
  };

  return (
    <div className={`${AuthHeaderStyle.authHeader} ${className}`}>
      <div className={AuthHeaderStyle.authHeader__activityBar}>
        <span className={AuthHeaderStyle.authHeader__left}>
          <span className={AuthHeaderStyle.authHeader__logo}>
            <p className={AuthHeaderStyle.authHeader__primaryLogo}>
              <img src={PayfiPrimaryLogo} alt="Payfi Primary Logo" />
            </p>
          </span>
        </span>

        <span className={AuthHeaderStyle.authHeader__right}>{renderAuthActions(pathname)}</span>
      </div>
    </div>
  );
};

export default AuthHeader;
